import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";
import Home from "@/pages/Home.vue";
import TwoFactor from "@/pages/TwoFactor.vue";
import Logout from "@/pages/Logout.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import Repairs from "@/pages/repairs/Repairs.vue";
import AddRepairs from "@/pages/repairs/AddRepairs.vue";
import EditStatus from "@/pages/repairs/EditStatus.vue";
import DeleteRepairs from "@/pages/repairs/Delete.vue";
import Customers from "@/pages/customers/Customers.vue";
import AddCustomer from "@/pages/customers/AddCustomer.vue";
import EditCustomer from "@/pages/customers/EditCustomer.vue";
import DeleteCustomer from "@/pages/customers/DeleteCustomer.vue";
import Inventory from "@/pages/inventory/List.vue";
import InventoryEdit from "@/pages/inventory/Edit.vue";
import ASFs from "@/pages/asfs/ASFs.vue";
import AddAsf from "@/pages/asfs/AddAsf.vue";
import EditAsf from "@/pages/asfs/EditAsf.vue";
import DeleteAsf from "@/pages/asfs/DeleteAsf.vue";
import Users from "@/pages/users/Users.vue";
import EditUser from "@/pages/users/EditUser.vue";
import AddUser from "@/pages/users/AddUser.vue";
import DeleteUser from "@/pages/users/DeleteUser.vue";
import RequestParts from "@/pages/parts/RequestParts.vue";
import RequestsList from "@/pages/requests/List.vue";
import RequestsDelete from "@/pages/requests/Delete.vue";
import RequestsEdit from "@/pages/requests/Edit.vue";
import Parts from "@/pages/parts/Parts.vue";
import PartsAdd from "@/pages/parts/AddPart.vue";
import PartsEdit from "@/pages/parts/EditPart.vue";
import PartsDelete from "@/pages/parts/Delete.vue";
import PartsImport from "@/pages/parts/ImportParts.vue";
import Documents from "@/pages/documents/List.vue";
import DocumentsAdd from "@/pages/documents/Add.vue";
import DocumentsDelete from "@/pages/documents/Delete.vue";
import Models from "@/pages/models/Add.vue";
import AssessmentsList from "@/pages/assessments/AssessmentsList.vue";
import AssessmentsAdd from "@/pages/assessments/AssessmentsAdd.vue";
import AssessmentsEdit from "@/pages/assessments/AssessmentsEdit.vue";
import AssessmentsDelete from "@/pages/assessments/AssessmentsDelete.vue";
import AssessmentsAnswer from "@/pages/assessments/AssessmentsAnswer.vue";
import AssessmentsResults from "@/pages/assessments/AssessmentsResults.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/login/2fa",
    name: "two-factor",
    component: TwoFactor
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout,
    meta: {
      roles: [
        "admin",
        "admin-rede",
        "asf-admin",
        "asf-frontdesk",
        "asf-technician"
      ]
    }
  },
  {
    path: "/admin/",
    component: DashboardLayout,
    redirect: "/admin/dashboard",
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: {
          roles: ["admin"]
        }
      },
      {
        path: "repairs",
        name: "repairs",
        component: Repairs,
        meta: {
          roles: [
            "admin",
            "admin-rede",
            "asf-admin",
            "asf-frontdesk",
            "asf-technician"
          ]
        }
      },
      {
        path: "repairs/new",
        name: "repairs_new",
        component: AddRepairs,
        meta: {
          roles: [
            "admin",
            "admin-rede",
            "asf-admin",
            "asf-frontdesk",
            "asf-technician"
          ]
        }
      },
      {
        path: "repairs/edit/:id",
        name: "repairs_edit",
        props: true,
        component: EditStatus,
        meta: {
          roles: [
            "admin",
            "admin-rede",
            "asf-admin",
            "asf-frontdesk",
            "asf-technician"
          ]
        }
      },
      {
        path: "repairs/delete/:id",
        name: "repairs_delete",
        component: DeleteRepairs,
        props: true,
        meta: {
          roles: ["admin"]
        }
      },
      {
        path: "request_parts/:cat?",
        name: "request_parts",
        component: RequestParts,
        props: true,
        meta: {
          roles: [
            "admin",
            "admin-rede",
            "asf-admin",
            "asf-frontdesk",
            "asf-technician"
          ]
        }
      },
      {
        path: "inventory",
        name: "inventory",
        component: Inventory,
        meta: {
          roles: [
            "admin",
            "admin-rede",
            "asf-admin",
            "asf-frontdesk",
            "asf-technician"
          ]
        }
      },
      {
        path: "inventory/edit/:id?",
        name: "inventory_edit",
        component: InventoryEdit,
        props: true,
        meta: {
          roles: ["admin"]
        }
      },
      {
        path: "customers",
        name: "customers",
        component: Customers,
        meta: {
          roles: ["admin", "admin-rede", "asf-admin"]
        }
      },
      {
        path: "customers/new",
        name: "customers_new",
        component: AddCustomer,
        meta: {
          roles: ["admin", "admin-rede", "asf-admin"]
        }
      },
      {
        path: "customers/edit/:id",
        name: "customers_edit",
        component: EditCustomer,
        props: true,
        meta: {
          roles: ["admin", "admin-rede"]
        }
      },
      {
        path: "customers/delete",
        name: "customers_delete",
        component: DeleteCustomer,
        meta: {
          roles: ["admin", "admin-rede"]
        }
      },
      {
        path: "asfs",
        name: "asfs",
        component: ASFs,
        meta: {
          roles: ["admin", "admin-rede"]
        }
      },
      {
        path: "asfs/new",
        name: "asfs_new",
        component: AddAsf,
        meta: {
          roles: ["admin", "admin-rede"]
        }
      },
      {
        path: "asfs/edit/:id",
        name: "asfs_edit",
        component: EditAsf,
        props: true,
        meta: {
          roles: ["admin", "admin-rede"]
        }
      },
      {
        path: "asfs/delete/:id",
        name: "asfs_delete",
        component: DeleteAsf,
        props: true,
        meta: {
          roles: ["admin", "admin-rede"]
        }
      },
      {
        path: "assessments",
        name: "assessments",
        component: AssessmentsList,
        meta: {
          roles: ["admin", "asf-admin"]
        }
      },
      {
        path: "assessments/new",
        name: "assessments_new",
        component: AssessmentsAdd,
        meta: {
          roles: ["admin"]
        }
      },
      {
        path: "assessments/edit/:id",
        name: "assessments_edit",
        component: AssessmentsEdit,
        meta: {
          roles: ["admin"]
        }
      },
      {
        path: "assessments/answer/:id",
        name: "assessments_answer",
        component: AssessmentsAnswer,
        meta: {
          roles: ["admin", "asf-admin"]
        }
      },
      {
        path: "assessments/results/:id",
        name: "assessments_results",
        component: AssessmentsResults,
        meta: {
          roles: ["admin", "asf-admin"]
        }
      },
      {
        path: "assessments/delete/:id",
        name: "assessments_delete",
        component: AssessmentsDelete,
        meta: {
          roles: ["admin"]
        }
      },
      {
        path: "users",
        name: "users",
        component: Users,
        meta: {
          roles: ["admin", "admin-rede", "asf-admin"]
        }
      },
      {
        path: "user/edit/:id",
        name: "user_edit",
        component: EditUser,
        props: true,
        meta: {
          roles: [
            "admin",
            "admin-rede",
            "asf-admin",
            "asf-frontdesk",
            "asf-technician"
          ]
        }
      },
      {
        path: "user/delete/:id",
        name: "user_delete",
        component: DeleteUser,
        props: true,
        meta: {
          roles: ["admin", "admin-rede", "asf-admin"]
        }
      },
      {
        path: "user/new",
        name: "user_new",
        component: AddUser,
        meta: {
          roles: ["admin", "admin-rede", "asf-admin"]
        }
      },
      {
        path: "requests",
        name: "requests",
        component: RequestsList,
        meta: {
          roles: ["admin", "asf-admin"]
        }
      },
      {
        path: "requests/edit/:id",
        name: "requests_edit",
        component: RequestsEdit,
        props: true,
        meta: {
          roles: ["admin", "asf-admin"]
        }
      },
      {
        path: "requests/delete/:id",
        name: "requests_delete",
        component: RequestsDelete,
        props: true,
        meta: {
          roles: ["admin", "asf-admin"]
        }
      },
      {
        path: "parts",
        name: "parts",
        component: Parts,
        meta: {
          roles: ["admin"]
        }
      },
      {
        path: "parts/new",
        name: "parts_new",
        component: PartsAdd,
        meta: {
          roles: ["admin"]
        }
    }, {
        path: "parts/import",
        name: "parts_import",
        component: PartsImport,
        meta: {
            roles: ["admin"]
        }
    },{
        path: "parts/:id/duplicate",
        name: "parts_duplicate",
        component: PartsEdit,
        meta: {
          roles: ["admin", "admin-rede", "asf-admin"]
        }
      },
      {
        path: "parts/edit/:id",
        name: "parts_edit",
        component: PartsEdit,
        props: true,
        meta: {
          roles: ["admin"]
        }
      },
      {
        path: "parts/delete/:id",
        name: "parts_delete",
        component: PartsDelete,
        props: true,
        meta: {
          roles: ["admin"]
        }
      },
      {
        path: "documents",
        name: "documents",
        component: Documents,
        meta: {
          roles: ["admin", "asf-admin", "asf-frontdesk", "asf-technician"]
        }
      },
      {
        path: "documents/new",
        name: "documents_new",
        component: DocumentsAdd,
        meta: {
          roles: ["admin"]
        }
      },
      {
        path: "models",
        name: "models",
        component: Models,
        meta: {
          roles: ["admin", "admin-rede"]
        }
      },
      {
        path: "documents/delete/:id",
        name: "documents_delete",
        component: DocumentsDelete,
        props: true,
        meta: {
          roles: ["admin"]
        }
      }
    ]
  },
  {
    path: "*",
    component: NotFound
  }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res = require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
